import React, { useState } from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DisciplinOgKarakter() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [hoveredSide, setHoveredSide] = useState<"left" | "right" | null>(null);
  return <section id="disciplin-og-karakter" ref={ref} className={cn("dark bg-background text-foreground w-full h-[85vh] min-h-[600px] flex flex-col md:flex-row overflow-hidden transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")}>
      {}
      <div className={cn("relative flex-1 flex flex-col justify-end p-8 md:p-12 transition-all duration-700 ease-in-out group border-b-2 md:border-b-0 md:border-r-2 border-border", hoveredSide === "left" ? "md:flex-[1.5]" : "md:flex-1", hoveredSide === "right" ? "md:flex-[0.6]" : "md:flex-1")} onMouseEnter={() => setHoveredSide("left")} onMouseLeave={() => setHoveredSide(null)}>
        {}
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors duration-500 z-10" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556341/img/royal_life_guard_bw.png" alt="Den Kongelige Livgarde i sort/hvid" className="w-full h-full object-cover grayscale contrast-125 transition-transform duration-700 group-hover:scale-105" />
        </div>

        {}
        <div className="relative z-20 max-w-xl">
          <h2 className="text-4xl md:text-6xl font-mono font-bold uppercase tracking-tighter text-white mb-4 drop-shadow-lg">
            Disciplin
          </h2>
          
          <div className={cn("overflow-hidden transition-all duration-500 ease-in-out", hoveredSide === "left" ? "max-h-96 opacity-100 translate-y-0" : "max-h-0 opacity-0 translate-y-4 md:max-h-0 md:opacity-0 md:translate-y-4 max-h-40 opacity-100 translate-y-0")}>
            <p className="text-lg md:text-xl text-gray-200 font-serif leading-relaxed mb-6 border-l-2 border-primary pl-4">
              Fra Den Kongelige Livgarde lærte jeg at stå fast. Pligt, ære og fysisk udholdenhed dannede fundamentet, men det var kun begyndelsen på rejsen mod sand styrke.
            </p>
            
            <Link to="/JourneyPage" className="inline-flex items-center gap-2 text-primary hover:text-white transition-colors font-mono uppercase tracking-wider text-sm font-bold">
              Læs om min tid i trøjen <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className={cn("relative flex-1 flex flex-col justify-end p-8 md:p-12 transition-all duration-700 ease-in-out group", hoveredSide === "right" ? "md:flex-[1.5]" : "md:flex-1", hoveredSide === "left" ? "md:flex-[0.6]" : "md:flex-1")} onMouseEnter={() => setHoveredSide("right")} onMouseLeave={() => setHoveredSide(null)}>
        {}
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-black/50 group-hover:bg-black/30 transition-colors duration-500 z-10" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1556341/img/prayer_book_reflection.png" alt="Bønnebog og refleksion" className="w-full h-full object-cover sepia-[0.3] transition-transform duration-700 group-hover:scale-105" />
        </div>

        {}
        <div className="relative z-20 max-w-xl ml-auto text-right">
          <h2 className="text-4xl md:text-6xl font-mono font-bold uppercase tracking-tighter text-white mb-4 drop-shadow-lg">
            Karakter
          </h2>
          
          <div className={cn("overflow-hidden transition-all duration-500 ease-in-out flex flex-col items-end", hoveredSide === "right" ? "max-h-96 opacity-100 translate-y-0" : "max-h-0 opacity-0 translate-y-4 md:max-h-0 md:opacity-0 md:translate-y-4 max-h-40 opacity-100 translate-y-0")}>
            <p className="text-lg md:text-xl text-gray-200 font-serif leading-relaxed mb-6 border-r-2 border-primary pr-4">
              Gennem troen fandt jeg styrken til at stå alene. Sand disciplin er ikke kun ydre eksercits, men indre ro, bøn og det moralske mod til at forsvare de svageste.
            </p>
            
            <Link to="/JourneyPage" className="inline-flex items-center gap-2 text-primary hover:text-white transition-colors font-mono uppercase tracking-wider text-sm font-bold">
              Min personlige transformation <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}